import { IconProps } from '../constants'
import SVGContainer from './svg-container'

const Download = (props: IconProps) => (
  <SVGContainer {...props} filled>
    <path d='M12 1.5a.75.75 0 01.75.75V7.5h-1.5V2.25A.75.75 0 0112 1.5zM11.25 7.5v5.69l-1.72-1.72a.75.75 0 00-1.06 1.06l3 3a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V7.5h3.75a3 3 0 013 3v9a3 3 0 01-3 3h-9a3 3 0 01-3-3v-9a3 3 0 013-3h3.75z' />
  </SVGContainer>
)

export default Download
